module.exports = __webpack_public_path__ + "img/copy.dec5d5cc.svg";